import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { EnterpriseSolutionsResponse } from "src/models/EnterpriseSolutionsResponse";
import { enterpriseSolutionsService } from "src/services/enterpriseSolutionsService";

export const RetrieveEnterpriseAdminRole = (
  userId: number,
  isDeviceEnabled?: boolean
): UseQueryResult<EnterpriseSolutionsResponse> =>
  useQuery<EnterpriseSolutionsResponse, Error>(
    ["elixrQuery", { userId }],
    async () => {
      const response = await enterpriseSolutionsService(
        userId,
        isDeviceEnabled
      );
      return response.data;
    },
    // only enable this query in dev for now until EES-88
    {
      enabled:
        userId !== undefined &&
        userId !== null &&
        userId !== -1 &&
        window.location.hostname.includes("dev"),
      retry: 4,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );
